import { usePluginOptionsStore } from '../../stores/pluginOptionsStore'

export class StoreHelper {
  /**
   * Loads configuration from the PluginOptions store (formerly rootState)
   * @param {string} endpoint - Optional endpoint key to retrieve URL
   * @returns {Object} Configuration object
   */
  static loadRootState(endpoint?: string | object) {
    // In Pinia, we access the store directly. Argument 'rootState' is ignored/removed.
    // If the first argument is passed as an object (legacy rootState), we ignore it if it's not a string.
    // But to be safe, we check if endpoint is a string.
    let targetEndpoint: string | undefined
    if (typeof endpoint === 'string') {
      targetEndpoint = endpoint
    } else if (arguments.length > 1 && typeof arguments[1] === 'string') {
       // If called as (rootState, endpoint)
       targetEndpoint = arguments[1]
    }

    const store = usePluginOptionsStore()
    const {
      atts, findAll, findOne, saveAll, saveOne, pluginOption
    } = store

    let url: string | undefined
    if (targetEndpoint && pluginOption) {
      url = (pluginOption as any)[targetEndpoint]
    }

    return {
      atts,
      findAll,
      findOne,
      pluginOption,
      saveAll,
      saveOne,
      url
    }
  }

  static error(result: any, defaultMessage: string) {
    let message = result.message || defaultMessage
    message = result.err
      ? (result.err.message || message)
      : message
    return new Error(message)
  }
}

export default {
  StoreHelper
}
